import { useEffect, useState } from "react";
import CardLayout from "../../../components/Layout/CardLayout";
import ReactTable from "../../../components/ReactDataTable/ReactTable";
import CashOnDeliveryForm from "./CashOnDeliveryForm";
import axios from "axios";
import toast from "react-hot-toast";
import { Button } from "react-bootstrap";
import DeleteModal from "../../../components/Modal/DeleteModal";

const CashOnDelivery = () => {
  const [modalOpen, setModalOpen] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [cashOneDeliveryData, setCashOnDeliveryData] = useState([]);

  useEffect(() => {
    (async function () {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/cash-on-delivery`,
        );

        if (data?.status === "OK") {
          setCashOnDeliveryData(data?.data);
        }
      } catch (err) {
        console.log(err);
      }
    })();
  }, [refresh]);

  const columns = [
    {
      key: "module_name",
      text: "Module Name",
    },
    {
      key: "module_key",
      text: "Module key",
    },
    {
      key: "status",
      text: "status",
      cell: (row) => (row?.status === 1 ? "Active" : "Inactive"),
    },
    {
      key: "action",
      text: "Action",
      cell: (row) => (
        <div>
          <Button
            size="sm"
            onClick={() => {
              setModalOpen("update");
              setSelectedItem(row);
            }}
          >
            <i className="fa fa-edit"></i>
          </Button>

          <Button
            size="sm"
            className="ms-2"
            variant="danger"
            onClick={() => {
              setModalOpen("delete");
              setSelectedItem(row);
            }}
          >
            <i className="fa fa-trash"></i>
          </Button>
        </div>
      ),
    },
  ];

  const onClose = () => {
    setModalOpen("");
    setSelectedItem(null);
  };

  const addNewCashOnDelivery = async (formData) => {
    try {
      console.log(formData);
      const { data } = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/cash-on-delivery`,
        formData,
      );

      if (data?.status === "OK") {
        toast.success("Cash on Delivery add Successfully");
        onClose();
        setRefresh((prev) => !prev);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const updateCashOnDelivery = async (formData) => {
    try {
      console.log(formData);
      const { data } = await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/cash-on-delivery/${selectedItem?.id}`,
        formData,
      );

      if (data?.status === "OK") {
        toast.success("Cash on Delivery update Successfully");
        onClose();
        setRefresh((prev) => !prev);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const deleteCashOnDelivery = async () => {
    try {
      const data = await axios.delete(
        `${process.env.REACT_APP_API_BASE_URL}/cash-on-delivery/${selectedItem?.id}`,
      );

      if (data?.status === 204) {
        toast.success("Cash on Delivery remove Successfully");
        onClose();
        setRefresh((prev) => !prev);
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <CardLayout
      title={"Cash on Delivery"}
      buttonTitle={"Add Cash On Delivery"}
      addButtonHandler={() => setModalOpen("create")}
    >
      <ReactTable data={cashOneDeliveryData} columns={columns} />

      {/*====================== Add New Cash on Delivery =======================*/}

      {modalOpen === "create" && (
        <CashOnDeliveryForm
          isOpen={modalOpen === "create"}
          onClose={onClose}
          apiHandler={addNewCashOnDelivery}
        />
      )}

      {modalOpen === "update" && (
        <CashOnDeliveryForm
          isOpen={modalOpen === "update"}
          onClose={onClose}
          apiHandler={updateCashOnDelivery}
          defaultData={selectedItem}
        />
      )}

      {modalOpen === "delete" && (
        <DeleteModal
          isOpen={modalOpen === "delete"}
          onClose={onClose}
          handleDelete={deleteCashOnDelivery}
        />
      )}
    </CardLayout>
  );
};

export default CashOnDelivery;
